<div class="content-container row mx-0">
  <div class="thumbnail-panel"
         [ngClass]="{
            'col-6': showBoxDrawing,
            'col-12': !showBoxDrawing
         }"
    >
    <div class="section-header" [class.section-header-with-search]="searchEnabled">
      <span class="panel-label">Select page</span>
      @if (searchEnabled) {
        <div class="page-search-container">
          <app-pdf-search
            [searchText]="searchText"
            [searchPerformed]="searchPerformed"
            [searchLoading]="searchLoading"
            [currentMatchNumber]="currentMatchNumber"
            [totalMatches]="totalMatches"
            [searchError]="searchError"
            (searchTextChange)="onSearchTextChange($event)"
            (searchSubmit)="onSearchSubmit()"
            (goToNext)="goToNextMatch()"
            (goToPrevious)="goToPreviousMatch()"
            (clearSearch)="onSearchClear()"
          ></app-pdf-search>
        </div>
      }
    </div>
    <div class="thumbnail-scroll-area row" appImgIntersectionObxList>
      @for (page of filteredPageImages; track trackByFn($index, page)) {
        <div
          class="fs-block fs-exclude thumbnail-div col-3"
          appImgIntersectionObx
          #intersection="intersection"
          #thumbnailElement
          [class.active]="page.pageIndex === activePageTrueIndex"
          >
          @if (intersection.hasIntersected) {
            <app-document-thumbnail
              [imageWidth]="150"
              [sourceImageUrl]="page.thumbnail.signedUrl"
              [page]="page"
              [boxes]="currentBoxesByPage[page.pageIndex]"
              (onImageClickEvent)="activatePage($event)"
              >
            </app-document-thumbnail>
          } @else {
            <div class="image-placeholder">
              ...
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if (showBoxDrawing) {
    <div class="col-6 col-container">
      <div class="section-header d-flex justify-content-between">
        <span class="panel-label">Draw box</span>
        <div class="zoom-controls">
          <i class="fas fa-search-plus hover icon" (click)="zoomIn()"></i>
          <i class="fas fa-search-minus hover" (click)="zoomOut()"></i>
          <div class="zoom-percentage">{{ MATH.floor(imgScale * 100) }}%</div>
        </div>
      </div>
      <div class="box-drawer-container" id="box-drawer-scroll-container">
        @if (activePageInFullArray?.normalRes?.signedUrl) {
          <div class="box-drawer-with-highlights">
            <app-box-drawer
              id="selected-page-image"
              [boxes]="currentBoxesByPage[activePageTrueIndex]"
              [sourceImageUrl]="activePageInFullArray.normalRes.signedUrl"
              [allowEdit]="true"
              [inputImageWidth]="boxDrawingWidth * imgScale"
              [onlyAllowOneBox]="allowOnlyOneBox"
              (boxesChanged)="boxesChanged.emit({boxes:$event, activePageIndex: activePageTrueIndex})"
              (imageLoadComplete)="onBoxDrawerImageLoaded()"
              scrollingContainerElementId="box-drawer-scroll-container"
              >
            </app-box-drawer>
            @if (searchPerformed && isViewerImageLoaded && displayHighlightsForCurrentPage.length > 0) {
              <div class="search-highlight-overlay"
                >
                @for (h of displayHighlightsForCurrentPage; track h) {
                  <div class="text-highlight"
                    [attr.data-highlight-id]="h.id"
                    [class.active]="h.id === activeHighlightId"
                    [style.left.px]="h.left"
                    [style.top.px]="h.top"
                    [style.width.px]="h.width"
                    [style.height.px]="h.height"
                  ></div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

</div>
